/*global describe*/
/*global require*/
/*global it*/
/*global console*/
/*global process*/
/*global exports*/
/*global Promise*/
/*global module*/

module.exports = {
    "lpsolve": require("./lpsolve/main.js")
};